<template>
  <div>
    <DeadlineRequirements
      v-if="currentDeadline"
      :current-deadline="currentDeadline"
      :missing-bank-account="onlyRequiresBankAccount"
    />
    <NonDeadlineRequirements
      v-else
      :currently-due="currentlyDue"
      :eventually-due="eventuallyDue"
      :past-due="pastDue"
    />
  </div>
</template>

<script type="text/babel">
import DeadlineRequirements from './DeadlineRequirements'
import NonDeadlineRequirements from './NonDeadlineRequirements'

export default {
  name: 'RequirementAlerts',
  components: {
    DeadlineRequirements,
    NonDeadlineRequirements,
  },
  props: {
    currentDeadline: {
      type: [Boolean, String],
      required: true,
    },
    requirements: {
      type: Object,
      required: true,
    },
    onlyRequiresBankAccount: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    currentlyDue() {
      if (this.requirements.requirements) {
        return [
          ...new Set([
            ...this.requirements.requirements.currently_due,
            ...this.requirements.futureRequirements.currently_due,
          ]),
        ]
      }

      return []
    },
    eventuallyDue() {
      if (this.requirements.requirements) {
        return [
          ...new Set([
            ...this.requirements.requirements.eventually_due,
            ...this.requirements.futureRequirements.eventually_due,
          ]),
        ]
      }

      return []
    },
    pastDue() {
      if (this.requirements.requirements) {
        return [
          ...new Set([
            ...this.requirements.requirements.past_due,
            ...this.requirements.futureRequirements.past_due,
          ]),
        ]
      }

      return []
    },
  },
}
</script>
